import { type RefObject } from "react";
import type React from "react";
import styles from "./tableData.module.scss";
import { isArray, isEmpty, isNil } from "lodash";
import { slotsListProps } from "../../../../infrastructure/GlobalContextProvider";


export interface GridTableProps {
  tableData: slotsListProps[];
  tableRef?: RefObject<HTMLTableElement>;
}

export default function GridTableComponent(props: GridTableProps): JSX.Element {
  console.log("----",props);
  const getTableData = (): React.ReactElement => {
    if (isNil(props.tableData)) {
      return <p>No Data</p>;
    } else if (isEmpty(props.tableData)) {
      return <p>No Data</p>;
    } else if (!isArray(props.tableData)) {
      return <p>No Data</p>;
    } else {
      return renderTable();
    }
  };

  const renderTable = (): React.ReactElement => {
    // const columnsToHide = ['id', 'isRegistered', 'isChanged'];
    return (
      <div className={styles.tableContainer}>
        <table className={styles.tableContainer} ref={props.tableRef}>
          <thead>
            <tr className={styles.headerTableRow}>
              {Object?.keys(props.tableData[0])?.map(
                (key: any, index: number) => (
                  <>
                  {key === 'isRegistered' || key === 'isChanged' || key=== 'id'  ? "" : <th className={styles.tableHorizontal} key={index}>
                    {key === "startTime"
                      ? "Start Time"
                      : key === "endTime"
                      ? "End Time"
                      : key === "taskDescription"
                      ? "Task Description"
                      : key === "overLay"
                      ? "Overlay"
                      : key}
                  </th> }
                  </>
                )
              )}
            </tr>
          </thead>
          <tbody>
            {props.tableData.map((item: any, index: number) => (
              <tr key={index} className={styles.tableRow}>
                {Object?.values(item)?.map((value: any, idx: number) => (
                  <>
                  {idx === (0) || idx === (3) || idx === (4) ? "" : 
                  <td className={styles.tableDiagonal} key={idx}>
                    {value}
                  </td> }
                  </>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };
  return <>{getTableData()}</>;
}
